import { render, staticRenderFns } from "./Auctioncenter.vue?vue&type=template&id=e97ca212&scoped=true&"
import script from "./Auctioncenter.vue?vue&type=script&lang=js&"
export * from "./Auctioncenter.vue?vue&type=script&lang=js&"
import style0 from "./Auctioncenter.vue?vue&type=style&index=0&id=e97ca212&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e97ca212",
  null
  
)

export default component.exports